<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="flex align-items">
			<h1>Conductor job {{ job.id }}</h1>
			<div class="small-margin-left">
				<ConductorJobStatus :job="job" :now="now" />
			</div>
			<div class="flex-grow text-right">
				<button v-on:click="load()">Refresh</button>
			</div>
		</div>

		<table class="margin-top">
			<tbody>
				<tr>
					<td style="width: 200px;"><strong>Flow</strong></td>
					<td>{{ job.flow }}</td>
				</tr>
				<tr>
					<td><strong>Step</strong></td>
					<td>{{ job.step }}</td>
				</tr>
				<tr>
					<td><strong>Attempts</strong></td>
					<td>{{ job.attempts }}</td>
				</tr>
				<tr>
					<td><strong>Model</strong></td>
					<td>
						<OrderLink v-if="job.model_type == 'order' && job.model_id" :id="job.model_id" />
						<template v-else-if="job.model_id">{{ job.model_type }} {{ job.model_id }}</template>
						<template v-else>—</template>
					</td>
				</tr>
				<tr>
					<td><strong>Run after</strong></td>
					<td>
						{{ localTime(job.run_after) }}
						<span class="note">({{ fromNow(job.run_after) }})</span>
					</td>
				</tr>
				<tr>
					<td><strong>Claimed until</strong></td>
					<td>{{ job.claimed_until ? localTime(job.claimed_until) : '—' }}</td>
				</tr>
				<tr>
					<td><strong>Dedupe key</strong></td>
					<td>{{ job.dedupe_key ? job.dedupe_key : '—' }}</td>
				</tr>
				<tr>
					<td><strong>Created</strong></td>
					<td>{{ localTime(job.created_at) }}</td>
				</tr>
				<tr>
					<td><strong>Updated</strong></td>
					<td>{{ localTime(job.updated_at) }}</td>
				</tr>
				<tr>
					<td><strong>Parent</strong></td>
					<td>
						<router-link v-if="job.parent_id" :to="'/conductor-job/' + job.parent_id">Job #{{ job.parent_id }}</router-link>
						<template v-else>—</template>
					</td>
				</tr>
			</tbody>
		</table>

		<div class="margin-top" v-if="job.last_error">
			<h2 class="small-margin-bottom">Last error</h2>
			<pre style="background: #ffaaaa;padding:15px;overflow:auto">{{ job.last_error }}</pre>
		</div>

		<div class="margin-top">
			<h2 class="small-margin-bottom">Input</h2>
			<pre style="background: #efefef;padding:15px;border:1px solid #ccc;overflow:auto">{{ JSON.stringify(job.input, null, 2) }}</pre>
		</div>

		<div class="margin-top">
			<h2 class="small-margin-bottom">State</h2>
			<pre style="background: #efefef;padding:15px;border:1px solid #ccc;overflow:auto">{{ JSON.stringify(job.state, null, 2) }}</pre>
		</div>

		<div class="margin-top" v-if="children.length">
			<h2 class="small-margin-bottom">Children</h2>
			<table>
				<thead>
					<tr>
						<th>ID</th>
						<th>Flow</th>
						<th>Step</th>
						<th>Status</th>
						<th>Run after</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="child in children">
						<td>
							<router-link :to="'/conductor-job/' + child.id">{{ child.id }}</router-link>
						</td>
						<td>{{ child.flow }}</td>
						<td>{{ child.step }}</td>
						<td>
							<ConductorJobStatus :job="child" :now="now" />
						</td>
						<td>{{ localTime(child.run_after) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import ConductorJobStatus from '@/components/ConductorJobStatus.vue'

export default {
  data: () => ({
    loading: false,
    job: {},
    children: [],
    now: null
  }),
  components: {
    ConductorJobStatus
  },
  watch: {
    '$route' () {
      this.load()
    }
  },
  methods: {
    localTime (value) {
      return moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss')
    },
    fromNow (value) {
      return moment.utc(value).from(moment.utc(this.now))
    },
    load () {
      Vue.$api.get('/conductor-jobs/' + this.$route.params.id, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.job = data.job
      this.children = data.children
      this.now = data.now
    }
  },
  created () {
    this.load()
  }
}
</script>
